export const reportColumnOptions = [
  'ID',
  'NF',
  'Emissão',
  'Prazo',
  'Previsão de Entrega',
  'Entrega',
  'Fornecedor',
  'Centro',
  'Origem',
  'Destino',
  'Transportadora',
  'Status',
].map((column) => ({
  value: column,
  label: column
}));